<template>
    <div class="home_page">
        <div class="topbox">
            <div class="centerTop">
                <div class="top_left">
                    <h1>Your new friend with benefits.</h1>
                    <div class="top_leftText">
                        Thousands of big-name benefits, supporting from nine to thrive. <br/>
                        <p style="width: 100%;height: 11px;"></p>
                        Beny is an employee benefits platform for Australian  <br/>organisations wanting to empower their people. Members get <br/> access to exclusive perks and insights that enhance their physical,  <br/>mental, social, and financial wellbeing. And then some.  <br/>
                        <p style="width: 100%;height: 11px;"></p>
                        Become a friend of Beny and unlock the Beny-fits today.
                    </div>

                    <div class="top_leftInput">
                        <el-input type="text" class="myHome_input" placeholder="Your Email Address" v-model="email" :class="{'is-error':emptyEmail}" @blur="blurEmail"></el-input>
                        <div class="pramyBtn topBtn" @click="toLogin">Get started</div>
                    </div>
                    <transition name="el-fade-in">
                        <div class="error_msg" v-show="errorMsg">{{errorMsg}}</div>
                    </transition>
                    <div class="btm-picture"></div>
                </div>
                <div class="top_right">
                    <img class="topIcon_img" src="https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/939590c6e39b48b9b531585abff352ae.png" alt="">
                </div>
            </div>
        </div>
        <section class="employeesBrand">
            <div class="left_r bold_text_h2">The <span class="lora_init">employee </span> benefits app. Where <span class="lora_init">everyone </span> benefits.
            </div>
            <h3 style="margin: 20px 0;">
                Beny plays to our strength in numbers. Bringing a collective of minority SME organisations together 
                to become a majority, we unlock leading benefits centred <br/>
                around wellbeing. Believing that gratitude 
                is core to the wellbeing journey, we proudly support charities like Black Dog Institute. When you buy 
                with Beny, <br/>you’re supporting the making of a mentally healthier Australia, together.
            </h3>
            <div class="left_r">
                <div class="pramyBtn w242 topBtn" @click="toNewLink(1)">View the Beny-Fits</div>
                <div class="pramyBtn w242 topBtn" @click="toNewLink(2)">About the Charity</div>
            </div>
            <div class="bold_text_h2 left_r" style="margin: 100px 0 20px 0;">Meet the Friends of Beny</div>
            <h3>Get a glimpse of what it’s like to be friends with Beny. Exclusive benefits from leading brands, one touch away:</h3>
            <div class="employees_iconList">
                <!--<img class="employees_icon" src="../../assets/home/n1.png" alt="">
                <img class="employees_icon" src="../../assets/home/n2.png" alt="">
                <img class="employees_icon" src="../../assets/home/n3.png" alt="">
                <img class="employees_icon" src="../../assets/home/n4.png" alt="">
                <img class="employees_icon" src="../../assets/home/n5.png" alt="">
                <img class="employees_icon" src="../../assets/home/n6.png" alt="">-->
                <img class="employees_icon" src="../../assets/home/e1.png" alt="">
                <img class="employees_icon" src="../../assets/home/e2.png" alt="">
                <img class="employees_icon" src="../../assets/home/e3.png" alt="">
                <img class="employees_icon" src="../../assets/home/e4.png" alt="">
                <img class="employees_icon" src="../../assets/home/e5.png" alt="">
                <img class="employees_icon" src="../../assets/home/e6.png" alt="">
                <img class="employees_icon" src="../../assets/home/e7.png" alt="">
                <img class="employees_icon" src="../../assets/home/e8.png" alt="">
            </div>
        </section>
        <section class="employeesBox1">
            <div class="employess_bigBox">
                <div class="employee_bigLeft">

                </div>
                <div class="employee_bigRight">
                    <div class="bigRight_tit">
                        We empower employers to empower <br/>their people.
                    </div>
                    <div class="bigRight_text">
                        Beny believes every Australian employee deserves access to benefits and resources that enhance 
                        their<span class="lora_init">wellbeing.</span> <br/>
                        <p style="width: 100%;height: 11px;"></p>
                        We know your team have a life outside of work. That’s why we look at the gaps that need to be filled
                        in between career and personal life, and plug them with a benefit that can support them: whether it’s mental, financial, physical, social wellbeing, or something else that holistically helps. 
                        <p style="width: 100%;height: 11px;"></p>
                        It’s time to<span class="lora_init">do good</span>for the people that move mountains, and make magic happen for the 
                        organisation. Because their success is your success.
                    </div>
                    <div class="pramyBtn w242 topBtn mar0" @click="toNewLink(3)">How Beny Works</div>
                    <!-- <div class="bigRight_Choose">Mental Wellbeing</div>
                    <div class="bigRight_Choose">Financial Wellbeing</div>
                    <div class="bigRight_Choose">Physical Wellbeing</div>
                    <div class="bigRight_Choose">Social Wellbeing</div> -->
                </div>
            </div>
        </section>
        <!-- <div class="roundLine"></div> -->
        <div class="svgLine_box">
            <svg
            preserveAspectRatio="none"
            viewBox="-450 -450 900 900"
            xmlns="http://www.w3.org/2000/svg"
            style="fill:#302E2C; width: 100%; height: 90px;"
            >
                <path d='M-466,-11 C0,-769 381,-148 453,-5'/>
            </svg>
        </div>
        <section class="benyBox">
            <div class="benyCenter">
                <!-- <div class="beny_desk"></div> -->
                <h2 class="benyBox_topTit">Wellness & wellbeing: all in the palm of your hand.</h2>
                <div class="beny_middleContant">
                    <div class="beny_midItem">
                        <img class="bney_icon" src="../../assets/home/beny1.png" alt="">
                        <div class="bney_title_mid">
                            Mental, physical, and <br>financial health benefits
                        </div>
                    </div>
                    <div class="beny_midItem">
                        <img class="bney_icon" src="../../assets/home/beny2.png" alt="">
                        <div class="bney_title_mid">
                            Wellbeing tips, learning <br>resources and advice
                        </div>
                    </div>
                    <div class="beny_midItem">
                        <img class="bney_icon" src="../../assets/home/beny3.png" alt="">
                        <div class="bney_title_mid">
                            Discounts for day-to-day <br>purchases
                        </div>
                    </div>
                </div>
                <div class="beny_footerBox">
                    <div class="beny_footerLeft">
                        <div class="bold_primaryText" style="margin-top:100px">
                            Employee attraction & retention has<br />never been easier.
                        </div>
                        <div class="primaryText margin20">
                            Created by HR industry professionals, for HR teams. We know resources can be limited in Human Resources, but Beny has your back.
                            <p style="width: 100%;height: 11px;"></p>
                            Beny is a smart device App that requires no complex integrations or inductions. Simply upload<br />
                            your employees and they will get almost instant access to Beny-fits via their smart phones or smart<br />
                            device. We’ve made things easy and accessible for everyone. Because that’s what friends are for.                        
                        </div>
                        <!--<div class="dashLine"></div>
                        <div class="primaryText">
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/>
                            Aliquam sit amet vehicula orci. Duis sed laoreet erat. <br/>
                            Integer rutrum metus ex."
                        </div>
                        <div class="beny_footerLeftBot">
                            <img class="bney_fUser" src="../../assets/home/checked.png" alt="">
                            Thomas Stevens ,
                            <span class="normal_text"> UX/UI Designer</span>
                        </div>-->
                    </div>
                    <div class="beny_footerRight">
                        <div class="deskIcon"></div>
                    </div>
                </div>
            </div>
        </section>
        <div class="svgLine_box" style="margin-top:-43px">
            <svg
            preserveAspectRatio="none"
            viewBox="-450 -450 900 900"
            xmlns="http://www.w3.org/2000/svg"
            style="fill:#302E2C; width: 100%; height: 90px;"
            >
                <path d='M-472,-34 C0,709 186,223 449,-15'/>
            </svg>
        </div>
        <section class="pringBox">
            <div class="pring_topBox">
                <div class="pring_footerRight">
                    <div class="deskIcon">
                        <div class="fix-box">
                            <div class="img">
                                <div class="like"></div>
                            </div>
                            <div class="text">
                                <p>28 by Sam Wood – half price<br />membership for you the first 3 months </p>
                                <div class="clear">
                                    <div class="star"></div>
                                    <div class="point">4.6</div>
                                    <div class="number">(83)</div>
                                </div>
                            </div>
                        </div>
                        <!-- <img class="pringTwoIcon" src="https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/a802f3f86d234ee19fdddd95472dda78.png" alt=""> -->
                    </div>
                </div>
                <div class="pring_footerLeft" style="margin-left:60px">
                    <div class="bold_primaryText" style="margin-top:88px">
                        Improve employee wellbeing with a <br/><span class="lora_init_bold" style="margin-left: 0;">Beny Day</span>
                    </div>
                    <div class="primaryText margin20">
                        Tackling 'life admin' can often be a time constraint – how often do we take time out of the day to review things like insurance, energy, telco, and other personal financial solutions? Imagine if you were able to give your employees a day off each year to do exactly this. Now you can. When employers implement Beny for their employees, they can also offer a Beny Day, an additional day of annual leave reserved for an employee to tackle those 'life admin' tasks such as delving into their financial matters each year. This can be reviewing home finance, insurances, utilities, physical health and wellness habits, social activities, managing digital health, finally accomplishing personal tasks at home, and even planning their next holiday. All of it can be done within the Beny App, via our Beny Partners.
                    </div>
                    <!--<div class="dashLine"></div>
                    <div class="primaryText">
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/>
                        Aliquam sit amet vehicula orci. Duis sed laoreet erat. <br/>
                        Integer rutrum metus ex."
                    </div>
                    <div class="pring_footerLeftBot">
                        <img class="bney_fUser" src="../../assets/home/checked.png" alt="">
                        Lucas Horne, 
                        <span class="normal_text"> Product Manager</span>
                    </div>-->
                </div>
            </div>
            <!--<div class="bold_primaryText pring_cnterTitle">
                Here's what our lovely users <br/>
                say about us
            </div>
            <carouselCard class="top_boxNew" />-->
        </section>
        <!--<div class="svgLine_box-carouselCard">
            <svg
            preserveAspectRatio="none"
            viewBox="-450 -450 900 900"
            xmlns="http://www.w3.org/2000/svg"
            style="fill:#302E2C; width: 100%; height: 90px;"
            >
                <path d='M-466,-11 C0,-769 381,-148 453,-5'/>
            </svg>
        </div>-->
        <section class="footerBox">
            <div class="footerBox_mian">
                <div class="centerFooter">
                    <div class="footerLeft">
                        <h2 class="footTitle">Partner up with Beny for Business</h2>
                        <div class="footText">
                            Beny is not just for your employees. The Beny network spans across thousands of Australian 
                            <p style="width: 100%;height: 11px;"></p>
                            businesses providing an expansive range of B2B and B2B products and services.
                            <p style="width: 100%;height: 11px;"></p>
                            Your organisation can be a part of our circle. If you are interested in providing a B2B or B2C offer on the Beny App, learn more about becoming a Beny Partner today.
                        </div>
                        <!--<div class="pramyBtn footerBtn" @click="$router.push('/registered')">Get started</div>-->
                        <div class="pramyBtn footerBtn" @click="contactShow(true)">Become a Beny Partner</div>
                    </div>
                    <div class="footerRight"></div>
                </div>
            </div>
        </section>

        <contact :show="showContact" @close="contactShow" />
    </div>
</template>

<script>
import CallApp from 'callapp-lib';
import carouselCard from '../common/card-carousel.vue'
import contact from '@/components/common/contact.vue'

export default {
    components:{carouselCard, contact},
    data() {
        return {
            email:'',
            emptyEmail:false,
            errorMsg:'',
            input:'',

            isPc: 2,
            route_infomation: {},
            showContact: false
        }
    },
    created() {
        this.route_infomation = this.$route.query
        let u = navigator.userAgent
        if (!!u.match(/compatible/i) || u.match(/Windows/i)) {
            this.isPc = 1
        } else if (!!u.match(/Macintosh/i) || u.match(/MacIntel/i)) {
            this.isPc = 1
        }  else if (!!u.match(/iphone/i) || u.match(/Ipad/i)) {
            this.isPc = 0
        } else if (!!u.match(/android/i)) {
            this.isPc = 0
        } else {
            this.isPc = 1
        }
        let route_infomation = this.$route.query
        if (!route_infomation.open)
            return
        if (this.isPc === 1) {
            Utils.alert('', ' This link will only work on iOS or Android.','error')
            return
        }

        // 唤起app
        if (route_infomation.open === 'benyDay') {
            this.jump()
            return
        }
    },
    methods: {
        contactShow(boo) {
            this.showContact = boo
        },
        jump() {
            let u = navigator.userAgent
            let isAndroid = /android/i.test(u)
        
            const callLib = new CallApp({
                scheme:{
                    protocol:'beny',
                    host:'beny.com.au',
                },
                intent: {
                    package: 'user.beny.com.au',
                    scheme: 'beny'
                },
                timeout:5000,
                appstore:''
            });
            callLib.open({
                param: {
                    web_id: 'benyDay'
                },
                path: 'benyDay',
                callback:()=>{
                    // 唤起失败处理
                    // history.push('/share')
                    if (isAndroid)
                        window.location = `beny://beny.com.au?web_id=benyDay`
                }
            });
            
        },
        blurEmail(){
            this.emptyEmail = this.email?false:true
            this.errorMsg = this.email?'':'Please enter your email address first.'
            if(this.emptyEmail) return false
            const regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
            if(!regEmail.test(this.email)){
                this.errorMsg = 'The email format entered is incorrect.'
                this.emptyEmail = true
                return false
            }
            return true
        },
        toNewLink(key){
            if(key === 1){
                this.$router.push('benefits')
            }else if(key === 2){
                this.$router.push('monthlyCharity')
            }else if(key === 3){
                this.$router.push('works')
            }
        },
        toLogin(){
            if(this.blurEmail()){
                this.$router.push(`/registered?email=${this.email}`)
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.home_page{
    position: relative;
    .topbox{
        width: 100%;
        height: 655px;
        background: #F1DADD;
        opacity: 1;
        border-radius: 0px;
        padding-top: 120px;
        .centerTop{
            display: flex;
            width: 1113px;
            margin: 0 auto;
            .top_left{
                margin: 0 100px 0 0;
                .btm-picture{
                    width: 100%;
                    height: 145px;
                    background-image: url('../../assets/home/yeah.png');
                    background-position: center center;
                    background-size: contain;
                    background-repeat: no-repeat;
                }
                h1{
                    min-width: 530px;
                    font-size: 52px;
                    font-family: DIN Next LT Pro-Black, DIN Next LT Pro;
                    font-weight: 900;
                    color: #3A3835;
                    line-height: 54px;
                }
                .top_leftText{
                    font-size: 18px;
                    font-weight: 400;
                    line-height: 22px;
                    color: #3A3835;
                    margin: 18px 0 24px 0;
                }
                .top_leftInput{
                    display: flex;
                    .myHome_input{
                        width: 313px;
                        height: 54px;
                        /deep/{
                            .el-input__inner{
                                height: 54px;
                                line-height: 54px;
                                border-color: #fff;
                                &::placeholder{
                                    color: #000;
                                    font-size: 17px;
                                    font-family: Assistant-Medium, Assistant;
                                }
                            }
                        }
                    }
                    .topBtn{
                        cursor: pointer;
                        width: 164px;
                        min-width: 164px;
                    }
                }
            }
            .top_right{
                .topIcon_img{
                    width: 501px;
                    height: 633px;
                }
            }
        }
    }
    .employeesBox1, .employeesBrand{
        width: 1210px;
        margin: 0 auto;
        h3{
            text-align: center;
            width: 100%;
            font-size: 18px;
            font-weight: 400;
            line-height: 27px;
            color: #FFFFFF;
            opacity: 0.8;
        }
        .employees_iconList{
            margin: 34px 0 130px 0;
            display: flex;
            height: 26px;
            align-items: center;
            .employees_icon{
                height: 54px;
                margin-right: 40px;
                &:nth-last-child(1){
                    margin-right: 0;
                }
            }
        }
        .employess_bigBox{
            display: flex;
            .employee_bigLeft{
                width: 540px;
                min-width: 540px;
                height: 498px;
                background: #F0F0F0;
                opacity: 1;
                background: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/7d1a924cad8f4ad3958e2c68d5ecd039.png') no-repeat;
                background-size: contain;
                border-radius: 8px;
            }
            .employee_bigRight{
                margin-left: 72px;
                .bigRight_tit{
                    margin-top: 54px;
                    width: 100%;
                    font-size: 38px;
                    font-weight: bold;
                    line-height: 44px;
                    color: #FFFFFF;
                    opacity: 1;
                }
                .bigRight_text{
                    font-size: 17px;
                    font-weight: 400;
                    line-height: 21px;
                    color: #FFFFFF;
                    opacity: 0.8;
                    margin: 20px 0 40px 0;
                }
                .bigRight_Choose{
                    height: 25px;
                    font-size: 18px;
                    font-weight: 400;
                    line-height: 25px;
                    color: #FFFFFF;
                    opacity: 1;
                    margin-bottom: 30px;
                    &::before{
                        display: inline-block;
                        content: ' ';
                        vertical-align: sub;
                        width: 21px;
                        height: 21px;
                        margin-right: 10px;
                        background: url('../../assets/home/checked.png') no-repeat;
                        background-size: contain;
                    }
                }
            }
        }
    }
    .employeesBox1{
        padding-top: 0;
        padding-bottom: 95px;
    }
    .employeesBrand{
        width: 1420px;
        padding-bottom: 0;
        padding-top: 217px;
    }
    .roundLine{
        width: 100%;
        height: 95px;
        background: #302E2C;
        border-radius: 65% 65% 65% 74%;
        overflow: hidden;
    }
    .svgLine_box{
        width: 100%;
        overflow: hidden;
    }
    .benyBox{
        margin-top: -53px;
        background: #302E2C;
        padding: 95px 0;
        .benyCenter{
            width: 1210px;
            margin: 0 auto;
            .beny_desk{
                width: 100%;
                height: 40px;
            }
            .benyBox_topTit{
                box-sizing: content-box;
                height: 52px;
                font-weight: bold;
                line-height: 56px;
                color: #FFFFFF;
                opacity: 1;
                width: 995px;
                text-align: center;
                font-size: 40px;
                padding:0px 0 88px 0;
                margin: 0 auto;
            }
            .beny_middleContant{
                width: 995px;
                margin: 0 auto;
                display: flex;
                box-sizing: content-box;
                justify-content: space-between;
                padding-bottom: 190px;
                .beny_midItem{
                    // flex: 1;
                    width: 270px;
                    // &:nth-child(2){
                    //     margin: 0 220px;
                    // }
                    .bney_icon{
                        height: 44px;
                    }
                    .bney_title_mid{
                        font-size: 22px;
                        font-family: Lora-Roman, Lora;
                        font-weight: normal;
                        line-height: 27px;
                        color: #FFFFFF;
                        opacity: 1;
                        margin: 24px 0 12px 0;
                        width: inherit;
                    }
                    .bney_text_mid{
                        font-size: 17px;
                        font-family: 'Assistant';
                        font-weight: 400;
                        line-height: 21px;
                        color: #FFFFFF;
                        opacity: 0.8;
                    }
                }
            }
            .beny_footerBox{
                display: flex;
                .beny_footerLeft{
                    .margin20{
                        margin-top: 20px;
                    }
                    .dashLine{
                        width: 420px;
                        height: 0px;
                        border: 1px dashed #FFFFFF;
                        opacity: 0.18;
                        margin: 31px 0 24px 0;
                    }
                    .beny_footerLeftBot{
                        height: 40px;
                        display: flex;
                        align-items: center;
                        margin-top: 24px;
                        font-size: 16px;
                        font-weight: bold;
                        .bney_fUser{
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                            margin-right: 10px;
                        }
                        .normal_text{
                            font-size: 15px;
                            font-weight: normal;
                            opacity: 0.8;
                            margin-left: 3px;
                        }
                    }
                }
                .beny_footerRight{
                    margin-left: auto;
                    .deskIcon{
                        width: 509px;
                        min-width: 509px;
                        background: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/55d239e8341f4176bae8faa3745c82aa.png') no-repeat;
                        background-size: contain;
                        height: 451px;
                        // background: #F0F0F0;
                        opacity: 1;
                        border-radius: 8px;
                    }
                }
            }
        }
    }
    .pringBox{
        width: 1230px;
        margin: 0 auto;
        padding: 95px 0 0px 0;
        position: relative;
        .pring_topBox{
            display: flex;
            .pring_footerLeft{
                .margin20{
                    margin-top: 20px;
                }
                .dashLine{
                    width: 420px;
                    height: 0px;
                    border: 1px dashed #FFFFFF;
                    opacity: 0.18;
                    margin: 31px 0 24px 0;
                }
                .pring_footerLeftBot{
                    height: 40px;
                    display: flex;
                    align-items: center;
                    margin-top: 24px;
                    font-size: 16px;
                    font-weight: bold;
                    .bney_fUser{
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        margin-right: 10px;
                    }
                    .normal_text{
                        font-size: 15px;
                        font-weight: normal;
                        opacity: 0.8;
                        margin-left: 3px;
                    }
                }
            }
            .pring_footerRight{
                margin-right: auto;
                .deskIcon{
                    width: 533px;
                    height: 483px;
                    background: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/d069fe8302ce48e4965317596585afa9.png') no-repeat;
                    background-size: 400px auto;
                    opacity: 1;
                    border-radius: 8px;
                    position: relative;
                    // .pringTwoIcon{
                    //     position: absolute;
                    //     top: 208px;
                    //     left: 209px;
                    //     width: 324px;
                    //     height: 275px;
                    // }
                    .fix-box{
                        position: absolute;
                        right: 0;
                        bottom: -32px;
                        width: 346px;
                        .img{
                            width: 100%;
                            height: 184px;
                            position: relative;
                            background: url('../../assets/home/nt.png') no-repeat;
                            background-size: cover;
                            .like{
                                width: 24px;
                                height: 24px;
                                // cursor: pointer;
                                position: absolute;
                                right: 10px;
                                top: 8px;
                                background: url('../../assets/home/heart1.png') no-repeat;
                                background-size: contain;
                            }
                        }
                        .text{
                            width: 100%;
                            background: #4E4C4A;
                            border-radius: 0px 0px 8px 8px;
                            box-sizing: border-box;
                            padding: 12px 0 12px 12px;
                            p{
                                font-size: 18px;
                                font-family: Lora-Roman, Lora;
                                font-weight: normal;
                                color: #FFFFFF;
                                line-height: 22px;
                                margin-bottom: 10px;
                            }
                            .star{
                                width: 14px;
                                height: 20px;
                                float: left;
                                margin-right: 3px;
                                background: url('../../assets/home/star1.png') no-repeat;
                                background-size: 14px auto;
                                background-position: center center;
                            }
                            .point{
                                float: left;
                                font-size: 14px;
                                font-family: Assistant-Regular, Assistant;
                                font-weight: 400;
                                color: #F6CC46;
                                line-height: 18px;
                                font-weight: 600;
                                margin-right: 3px;
                            }
                            .number{
                                float: left;
                                font-size: 14px;
                                font-family: Assistant-Regular, Assistant;
                                font-weight: 400;
                                color: #CACAC9;
                                line-height: 18px;
                            }
                        }
                    }
                }
            }
        }
        .pring_cnterTitle{
            text-align: center;
            box-sizing: content-box;
            padding: 170px 0 40px 0;
        }
    }
    .svgLine_box-carouselCard{
        width: 100%;
        overflow: hidden;
        margin-top: -250px;
    }
    .footerBox{
        width: 100%;
        padding:  0 40px;
        min-width: 1400px;
        // background-color: #302E2C;
        // background: linear-gradient(180deg, #302E2C 0%, rgba(48, 46, 44, 0.1) 100%);
        // position: relative;
        padding-top: 290px;
        // margin-top: -51px;
        .footerBox_mian{
            width: 100%;
            height: 461px;
            opacity: 1;
            box-sizing: border-box;
            border-radius: 0px;
            background: #F1DADD;
        }
        .centerFooter{
            display: flex;
            width: 1300px;
            margin: 0 auto;
            .footerLeft{
                .footTitle{
                    margin-top: 60px;
                    width: 700px;
                    font-size: 52px;
                    font-family: DIN Next LT Pro-Black, DIN Next LT Pro;
                    font-weight: 900;
                    color: #3A3835;
                    line-height: 60px;
                    color: #3A3835;
                    opacity: 1;
                }
                .footText{
                    margin: 18px 0 24px 0;
                    font-size: 18px;
                    font-family: Assistant-Medium, Assistant;
                    font-weight: 500;
                    color: #3A3835;
                    line-height: 22px;
                }
                .footerBtn{
                    font-size: 17px;
                    font-family: Assistant-Bold, Assistant;
                    font-weight: bold;
                    color: #3A3835;
                    width: 222px;
                    margin: 0;
                }
            }
            .footerRight{
                margin-left: 115px;
                margin-top: -60px;
                width: 505px;
                min-width: 505px;
                height: 422px;
                background: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/359f010ae977448cae546fe1f040de9b.png') no-repeat;
                background-size: contain;
                opacity: 1;
                border-radius: 8px;
            }
        }
    }
    .pramyBtn{
        cursor: pointer;
        height: 54px;
        text-align: center;
        line-height: 54px;
        background: #F8A4AE;
        opacity: 1;
        border-radius: 4px;
        margin-left: 20px;
        font-size: 17px;
        font-weight: bold;
        font-family: Assistant-Bold, Assistant;
        font-weight: bold;
        color: #3A3835;
    }
    .w242{
        width: 242px;
    }
    .mar0{
        margin: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/home/home.vue